import axios from "axios";
import { useEffect } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PHONE = "(417) 413-2882";
export const PHONE_TEL = "tel:+14174132882";
export const EMAIL = "showmeshield@gmail.com";

export const COVERAGE_OPTIONS = [
  "Accident",
  "Critical Illness",
  "Cancer",
  "Heart / Stroke",
  "Hospital Indemnity",
  "Life Insurance",
  "Individual & Family Health",
  "Not sure yet",
];

export const HELP_OPTIONS = ["Supplemental Insurance", "Life Insurance", "Health Insurance", "Family Protection", "Not Sure Yet"];

export const track = (event, data = {}) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }
};

export const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    referrer: document.referrer || "",
  };
};

export const initAnalytics = () => {
  const id = process.env.REACT_APP_GA_ID;
  if (!id || typeof window === "undefined" || window.__gaLoaded) return;
  window.__gaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", id);
};

export const postLead = (payload) => axios.post(`${API}/leads`, payload);
export const postChecklist = (payload) => axios.post(`${API}/checklist`, payload);
export const postBooking = (payload) => axios.post(`${API}/bookings`, payload);

export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://showmeshield.com";

export const usePageMeta = (title, description, opts = {}) => {
  const { path, noindex } = opts;
  useEffect(() => {
    document.title = title;
    const setMeta = (selector, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const m = selector.match(/\[(name|property)="(.+?)"\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
    }
    setMeta('meta[property="og:title"]', title);
    const pagePath = path ?? window.location.pathname;
    setMeta('meta[property="og:url"]', `${SITE_URL}${pagePath}`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${pagePath}`);
    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) setMeta('meta[name="robots"]', "noindex, nofollow");
    else if (robots) robots.remove();
  }, [title, description, path, noindex]);
};
